export default {
  page_name: "Absen Per Mata Pelajaran",
  select_date: "Pilih Tanggal",
  day: "Hari"
};
